import { BookImage, FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { getAuthorNames } from '@fable/utils'
import { routes } from 'app/store/routes'
import { useBuyBook } from 'hooks'
import { Link } from 'react-router-dom'
import { getSlug } from 'utils'

export const BookCarouselItem = ({
  className,
  book,
  hidden = false,
  rel,
}: {
  className?: string
  book: Partial<Book>
  hidden?: boolean
  rel?: string
}) => {
  const { motion, mediaQueries } = useTheme()
  const { inCart, owned, preorder } = useBuyBook({ book: book as Book })

  if (!book) return null

  const determineLabel = () => {
    if (inCart) return 'In Cart'
    if (preorder && owned) return 'Preordered'
    if (owned) return 'Already Owned'
    if (book?.price_usd === '0.00') return 'Free'
    if (book?.price_usd) return `$${book.price_usd}`
    return ''
  }

  const labelTitle = determineLabel()

  return (
    <Link
      to={`${routes.book}/${getSlug(book.url)}`}
      rel={rel}
      className={css`
        display: block;
        height: 100%;
        ${mediaQueries.tabletL} {
          opacity: ${hidden ? 0 : 1};
          pointer-events: ${hidden ? 'none' : 'auto'};
          ${motion.transition('opacity')}
        }
      `}
    >
      <FlexBox
        className={css`
          height: inherit;
        `}
        flexDirection="column"
        justifyContent="space-between"
      >
        <div>
          <div
            className={cx(
              css`
                position: relative;
                border-radius: 8px;
                overflow: hidden;
              `,
              className
            )}
          >
            <BookImage
              className={css`
                width: 100%;
                height: 237px;
                border-radius: 0;
                img {
                  height: 100%;
                }
                ${mediaQueries.mobileL} {
                  height: 245px;
                }
              `}
              image={book.cover_image as string}
              altTag={`${book.title} book cover`}
              size={400}
            />
          </div>
          <Text
            className={css`
              font-weight: 600;
              margin: 5px 0px 8px 0px;
            `}
            tag="p"
            type="subhead"
            sizing="XS"
            text={book.title || ''}
            truncate={2}
          />
          <Text
            type="body"
            sizing="S"
            text={getAuthorNames(book.authors) || ''}
            truncate={2}
          />
        </div>
        {labelTitle && (
          <Text
            className={cx(
              css`
                font-weight: 400;
              `,
              owned &&
                css`
                  padding: 4px 8px;
                  background: rgba(7, 6, 7, 0.1);
                  border-radius: 8px;
                  width: fit-content;
                `
            )}
            type="body"
            sizing="S"
          >
            {labelTitle}
          </Text>
        )}
      </FlexBox>
    </Link>
  )
}
